import React, { useEffect, useState } from 'react';
import Blog from './Blog.js';
import Header from './Header.js';
import axios from 'axios';
import { environmentVariables } from '../../../config/env.config.js';
import './MainBlog.css'
import { fetchBlogs } from '../../../ApiHelper.js';

export default function Mainblog() {
  const [blogPosts, setBlogPosts] = useState([]); 
  const [popularBlogPosts, setPopularBlogPosts] = useState([]); 
  const [loading, setLoading] = useState(true);

  
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetchBlogs();
        setBlogPosts(response?.data?.data || []);
      } catch (error) {
        console.error("Fetch Error:", error);
      }finally{
        setLoading(false);
      }
    };
  
    fetchData();
  }, []);

  const fetchPopularBlogs = async () => {
    try {
      const response = await axios.get(
        `${environmentVariables?.apiUrlBlogs}api/v1/user/get-random-blog-by-type`,
        { params: { type: 'be' } }
      );

      console.log("Full API Response:", response);

      if (response?.data?.statusCode === 200) {
        console.log("Blogs Data:", response.data.data);
        setPopularBlogPosts(response.data.data || []); // Ensure it's an array
      } else {
        console.error("API Error:", response.data?.message);
      }
    } catch (error) {
      console.error("Fetch Error:", error);
      setPopularBlogPosts([])
    }
  };

  useEffect(() => {
    fetchBlogs();
    fetchPopularBlogs()
  }, []);

  return (
    <div className="MainBlog">
      <Header />
      <Blog blogPosts={blogPosts} popularPosts={popularBlogPosts} loading={loading} />
    </div>
  );
}